// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__4Tezh","localeActive":"LanguageSwitcher_localeActive__dgtaS"};